<template>
	<div class="form_combination">
		<el-form
			ref="formData"
			:model="formData"
			size="medium"
			:style="[formStyle]"
			:label-width="labelWidth"
			:label-position="labelPosition"
		>
			<template v-for="(item, index) in formData">
				<el-col
					v-if="typeof item.displayWith !== 'function' || item.displayWith(formData, item)"
					:span="item.col"
					:style="item.style || item.colStyle"
					:key="index"
				>
					<el-form-item v-bind="item" v-if="item.show !== true" :prop="getProp(item, index)">
						<customComponent
							v-if="item.type === 'custom'"
							:component-name="item.formType"
							v-model="item.value"
							v-bind="item"
							v-on="$listeners"
							@input="item.change"
						></customComponent>
						<component
							v-else
							:is="item.formType"
							v-model="item.value"
							v-bind="item"
							:placeholder="item.placeholder"
							:inputType="item.inputType"
							:scope="item"
							@input="item.change"
							v-on="$listeners"
						></component>
					</el-form-item>
				</el-col>
			</template>
			<!-- <slot></slot> -->
			<el-col style="margin-left: 100px;" v-if="showBtn">
				<el-button @click="onClose">取消</el-button>
				<el-button type="primary" @click="sure()" :loading="loading">确定</el-button>
				<!-- <el-button @click="reset('formData')">重置</el-button> -->
			</el-col>
		</el-form>
	</div>
</template>
<script>
import formComponent from '@/components/iglobalwin/formComponents/index.js';
import customComponent from '@/components/tools/customComponent';
import Vue from 'vue';
export default {
	name: 'form_combination',
	props: {
		formData: {
			required: true,
		},
		showBtn: {
			type: Boolean,
			default: false,
		},
		labelWidth: {
			type: String,
			default: '150px',
		},
		labelPosition: {
			type: String,
			default: 'right',
		},
		formStyle: {
			required: false,
		},
	},
	components: { ...formComponent, customComponent },
	data() {
		return {
			loading: false,
		};
	},
	computed: {},
	methods: {
		getProp(item, idx) {
			return `${idx}.value`;
		},
		validate(cb) {
			this.$refs.formData.validate(valid => {
				cb(valid);
			});
		},
		sure() {
			this.$refs.formData.validate(valid => {
				if (valid) {
					this.$emit(
						'submit',
						() => {
							this.loading = false;
						},
						() => {
							this.reset('formData');
						}
					);
				}
			});
		},
		reset() {
			this.$refs.formData.resetFields();
		},
		onClose() {
			this.$emit('onclose');
		},
		clearValidate(props) {
			this.$refs.formData.clearValidate(props);
		},
	},
	mounted() {
		const that = this;
		Vue.prototype.$formMethods = {
			validate: that.validate,
			reset: that.reset,
		};
	},
};
</script>
<style lang="scss">
.form_combination {
  .el-form {
    overflow: hidden;

    .el-form-item__label {
      padding: 0 46px 0 0;
    }

    .el-form-item {
      margin-bottom: 20px;
    }
  }
}

// 富文本编辑器初始高度
.ql-editor {
  min-height: 220px;
}
</style>
